/* tslint:disable */
/* eslint-disable */
/**
 * Venue Loyalty API
 * Onyx Gaming Venue Loyalty API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated.
 * Do not edit the class manually.
 */
import { exists, mapValues } from './model-utils';
import type { GetPlayerActivityStatement200ResponseHeader9Inner } from './GetPlayerActivityStatement200ResponseHeader9Inner';
import {
    GetPlayerActivityStatement200ResponseHeader9InnerFromJSON,
    GetPlayerActivityStatement200ResponseHeader9InnerFromJSONTyped,
    GetPlayerActivityStatement200ResponseHeader9InnerToJSON,
    instanceOfGetPlayerActivityStatement200ResponseHeader9Inner,
} from './GetPlayerActivityStatement200ResponseHeader9Inner';
import type { GetPlayerActivityStatement200ResponseMonthlyActivityInner } from './GetPlayerActivityStatement200ResponseMonthlyActivityInner';
import {
    GetPlayerActivityStatement200ResponseMonthlyActivityInnerFromJSON,
    GetPlayerActivityStatement200ResponseMonthlyActivityInnerFromJSONTyped,
    GetPlayerActivityStatement200ResponseMonthlyActivityInnerToJSON,
    instanceOfGetPlayerActivityStatement200ResponseMonthlyActivityInner,
} from './GetPlayerActivityStatement200ResponseMonthlyActivityInner';

/**
 * 
 * @export
 * @interface GetPlayerActivityStatement200Response
 */
export interface GetPlayerActivityStatement200Response {
    /**
     * 
     * @type {string}
     * @memberof GetPlayerActivityStatement200Response
     */
    header1?: string;
    /**
     * 
     * @type {string}
     * @memberof GetPlayerActivityStatement200Response
     */
    firstName?: string;
    /**
     * 
     * @type {string}
     * @memberof GetPlayerActivityStatement200Response
     */
    lastName?: string;
    /**
     * 
     * @type {string}
     * @memberof GetPlayerActivityStatement200Response
     */
    period?: string;
    /**
     * 
     * @type {string}
     * @memberof GetPlayerActivityStatement200Response
     */
    patronID?: string;
    /**
     * 
     * @type {string}
     * @memberof GetPlayerActivityStatement200Response
     */
    netWinLoss?: string;
    /**
     * 
     * @type {string}
     * @memberof GetPlayerActivityStatement200Response
     */
    numberOfDays?: string;
    /**
     * 
     * @type {string}
     * @memberof GetPlayerActivityStatement200Response
     */
    totalTime?: string;
    /**
     * 
     * @type {string}
     * @memberof GetPlayerActivityStatement200Response
     */
    header8?: string;
    /**
     * 
     * @type {Array<GetPlayerActivityStatement200ResponseHeader9Inner>}
     * @memberof GetPlayerActivityStatement200Response
     */
    header9?: Array<GetPlayerActivityStatement200ResponseHeader9Inner>;
    /**
     * 
     * @type {Array<GetPlayerActivityStatement200ResponseMonthlyActivityInner>}
     * @memberof GetPlayerActivityStatement200Response
     */
    monthlyActivity?: Array<GetPlayerActivityStatement200ResponseMonthlyActivityInner>;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetPlayerActivityStatement200Response
     */
    notes?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof GetPlayerActivityStatement200Response
     */
    pasLastViewedDate?: string;
}


/**
 * Check if a given object implements the GetPlayerActivityStatement200Response interface.
 */
export function instanceOfGetPlayerActivityStatement200Response(value: object): boolean {
    let isInstance = true;
    return isInstance;
}

export function GetPlayerActivityStatement200ResponseFromJSON(json: any): GetPlayerActivityStatement200Response {
    return GetPlayerActivityStatement200ResponseFromJSONTyped(json, false);
}

export function GetPlayerActivityStatement200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetPlayerActivityStatement200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {

        'header1': !exists(json, 'header1') ? undefined : json['header1'],
        'firstName': !exists(json, 'firstName') ? undefined : json['firstName'],
        'lastName': !exists(json, 'lastName') ? undefined : json['lastName'],
        'period': !exists(json, 'period') ? undefined : json['period'],
        'patronID': !exists(json, 'patronID') ? undefined : json['patronID'],
        'netWinLoss': !exists(json, 'netWinLoss') ? undefined : json['netWinLoss'],
        'numberOfDays': !exists(json, 'numberOfDays') ? undefined : json['numberOfDays'],
        'totalTime': !exists(json, 'totalTime') ? undefined : json['totalTime'],
        'header8': !exists(json, 'header8') ? undefined : json['header8'],
        'header9': !exists(json, 'header9') ? undefined : ((json['header9'] as Array<any>).map(GetPlayerActivityStatement200ResponseHeader9InnerFromJSON)),
        'monthlyActivity': !exists(json, 'monthlyActivity') ? undefined : ((json['monthlyActivity'] as Array<any>).map(GetPlayerActivityStatement200ResponseMonthlyActivityInnerFromJSON)),
        'notes': !exists(json, 'notes') ? undefined : json['notes'],
        'pasLastViewedDate': !exists(json, 'pasLastViewedDate') ? undefined : json['pasLastViewedDate'],
    };
}

export function GetPlayerActivityStatement200ResponseToJSON(value?: GetPlayerActivityStatement200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {

        'header1': value.header1,
        'firstName': value.firstName,
        'lastName': value.lastName,
        'period': value.period,
        'patronID': value.patronID,
        'netWinLoss': value.netWinLoss,
        'numberOfDays': value.numberOfDays,
        'totalTime': value.totalTime,
        'header8': value.header8,
        'header9': value.header9 === undefined ? undefined : ((value.header9 as Array<any>).map(GetPlayerActivityStatement200ResponseHeader9InnerToJSON)),
        'monthlyActivity': value.monthlyActivity === undefined ? undefined : ((value.monthlyActivity as Array<any>).map(GetPlayerActivityStatement200ResponseMonthlyActivityInnerToJSON)),
        'notes': value.notes === undefined ? undefined : value.notes,
        'pasLastViewedDate': value.pasLastViewedDate,
    };
}

